import { useEffect } from 'react'

let locked = false

export default function useStableVh() {
  useEffect(() => {
    if (locked) return

    const set = () => {
      document.documentElement.style.setProperty(
        '--stable-vh',
        `${window.innerHeight}px`,
      )
    }

    set()
    locked = true

    const onResize = () => {
      if (window.scrollY === 0) set()
    }

    window.addEventListener('orientationchange', () => {
      setTimeout(set, 150)
    })
    window.addEventListener('resize', onResize)

    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])
}
